import { z } from 'zod'
import { Patent } from '~/shared/api'
import { stringRequiredScheme } from '~/shared/lib/schemas'

export const formSchema = Patent.schema
  .pick({
    number: true,
    issuedDate: true,
    expirationDate: true,
    issuedBy: true,
    paidAmount: true,
  })
  .extend({
    number: stringRequiredScheme,
  })

export type FormValues = z.infer<typeof formSchema>
